export default __webpack_public_path__ + "static/media/sidebar-1.0a127c58.jpg";